import type { BoxProps } from "@mui/material";
import type React from "react";
import { createContext, useContext, useMemo } from "react";

export interface IListVirtualizedContext {
  List?: BoxProps;
  ListItem?: BoxProps;
}

interface IListVirtualizedContextProps extends IListVirtualizedContext {
  children: React.ReactNode;
}

const context = createContext<IListVirtualizedContext>({});

export const useListVirtualizedContext = () => useContext(context);

export const ListVirtualizedProvider = ({ children, ...props }: IListVirtualizedContextProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const value = useMemo(() => ({ ...props }), [props.List, props.ListItem]);

  return <context.Provider value={value}>{children}</context.Provider>;
};
